module.exports = {
  // 需要统计数据的路由列表
  routeList: [
    {
      name: 'browseAndEarnHome',
      route: '/browseAndEarn/home', // 页面路由
      pageId: 'D1043', // pageId从zeye上拷贝
      level: 2 // 页面级别
    },
    {
      name: 'newEarnSignInPage',
      route: '/earn/signInPage', // 页面路由
      pageId: 'A2393', // pageId从zeye上拷贝
      level: 3 // 页面级别
    },
    {
      name: 'exposureHome',
      route: '/exposure/home', // 页面路由
      pageId: 'P4539', // pageId从zeye上拷贝
      level: 2 // 页面级别
    },
    {
      name: 'exposureList',
      route: '/exposure/list', // 页面路由
      pageId: 'S3305', // pageId从zeye上拷贝
      level: 2 // 页面级别
    }
  ]
}
